import { IResponse } from '../interfaces/IResponse';

const DefaultResponse = {
  status: 500,
  message: 'Ha ocurrido un error por favor internarlo más tarde',
  data: {
    0: {},
    error: {}
  }
}

export const catchErrorInsurances = (err: any) : IResponse => {
  console.log("entro catchError");
  return err;

  // if( !err.hasOwnProperty('data') ) {
  //   return DefaultResponse;
  // }

  // const { data } = err;
  // return data.hasOwnProperty('error') ? err : DefaultResponse;
};
